import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthProvider';
import axios from 'axios';
import socket from '../socket';
import logo from '../assets/blinkurl-logo.svg';
import '../css/LoginPage.css';

function LoginPage() {
  const { login, setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [error, setError] = useState('');

  const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://urlshortener-serverside.onrender.com/api';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${BASE_URL}/auth/login`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      });

      if (response.status === 200) {
        const { token, username } = response.data;

        localStorage.setItem('token', token);
        localStorage.setItem('username', username);

        login();
        setIsAuthenticated(true);

        socket.emit('user_logged_in', { username });

        // Navigate to the dashboard after successful login
        navigate('/dashboard');
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-grid">
        <div className="login-illustration">
          <div className="login-card-art">
            <div className="card-bar">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="card-body">
              <div className="card-pill">
                <div className="card-link-icon"></div>
                short.ly/xYz123
              </div>
              <div className="card-chart"></div>
              <div className="card-megaphone"></div>
            </div>
          </div>
        </div>

        <div className="login-panel">
          <div className="login-brand">
            <img src={logo} alt="BlinkURL logo" />
            <div>
              <h3>BlinkURL</h3>
              <span>Simplify Your Links</span>
            </div>
          </div>

          <h2>Login to Your Account</h2>
          {error && <div className="login-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <label className="login-field">
              <span>Username</span>
              <div className="input-row">
                <i className="icon user"></i>
                <input
                  id="username"
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Enter your username"
                  required
                />
              </div>
            </label>
            <label className="login-field">
              <span>Password</span>
              <div className="input-row">
                <i className="icon lock"></i>
                <input
                  id="password"
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                />
              </div>
            </label>
            <div className="login-row">
              <button type="submit">Login</button>
              <Link to="/support" className="forgot-link">
                Forgot Password?
              </Link>
            </div>
          </form>
          <p className="login-footer">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
